import type { ReactNode } from "react";
import { cn } from "../../lib/utils";

export function Metric({
  label,
  value,
  tone = "default",
  icon,
}: {
  label: string;
  value: ReactNode;
  tone?: "default" | "critical" | "warning" | "water";
  icon?: ReactNode;
}) {
  const toneClass = {
    default: "text-navy-900",
    critical: "text-red-700",
    warning: "text-amber-700",
    water: "text-water-600",
  }[tone];
  return (
    <div className="rounded-lg border border-slate-200 bg-white p-4">
      <div className="flex items-center justify-between gap-3">
        <p className="text-sm text-slate-600">{label}</p>
        {icon ? <span className="text-slate-400">{icon}</span> : null}
      </div>
      <p className={cn("mt-2 text-2xl font-bold", toneClass)}>{value}</p>
    </div>
  );
}
